import { Button } from "@chakra-ui/react";
import { AlertsContext } from "providers/alerts";
import { useContext } from "react";
import { apiRequest } from "utils/api";

const DeleteItemBtn = ({ item, disabled }: { item: any; disabled: any }) => {
  const { showSuccess, showError } = useContext(AlertsContext);

  const deleteItem = async () => {
    try {
      await apiRequest("/supabase/loan_items/delete", {
        id: item.id,
      });
      showSuccess({
        title: "Item Deleted",
        description: "The checklist item was successfully deleted.",
      });
    } catch (err) {
      showError({
        title: "Item Not Deleted",
        description:
          "Something went wrong and the checklist item was not deleted.",
      });
    }
  };

  return (
    <Button
      variant="outline"
      colorScheme="red"
      onClick={deleteItem}
      isDisabled={disabled}
    >
      Delete
    </Button>
  );
};

export default DeleteItemBtn;
